import {h, Fragment} from "preact"
export default function SubmitButton({ className, text, onClick }) {
    return (
        <button type="submit" className={`ns-submit-btn ${className}`} onClick={onClick}>
            {text}
        </button>
    )
}